module.exports = __webpack_public_path__ + "img/prj07.04a9559d.png";